var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7273 7.25H16.4432V6.87C16.4432 4.457 14.4534 2.5 12 2.5C9.54659 2.5 7.55682 4.457 7.55682 6.87V7.25H4.27273C3.84531 7.25 3.5 7.58962 3.5 8.01V20.74C3.5 21.1604 3.84531 21.5 4.27273 21.5H19.7273C20.1547 21.5 20.5 21.1604 20.5 20.74V8.01C20.5 7.58962 20.1547 7.25 19.7273 7.25ZM9.29545 6.87C9.29545 5.39987 10.5053 4.21 12 4.21C13.4947 4.21 14.7045 5.39987 14.7045 6.87V7.25H9.29545V6.87ZM18.7614 19.79H5.23864V8.96H7.55682V11.05C7.55682 11.1545 7.64375 11.24 7.75 11.24H9.10227C9.20852 11.24 9.29545 11.1545 9.29545 11.05V8.96H14.7045V11.05C14.7045 11.1545 14.7915 11.24 14.8977 11.24H16.25C16.3562 11.24 16.4432 11.1545 16.4432 11.05V8.96H18.7614V19.79Z",
    fill: "#FF7A00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketActive);
export default __webpack_public_path__ + "static/media/market-active.4e7b0526a123a6e2c8b6ad3c630a828a.svg";
export { ForwardRef as ReactComponent };